import { useRef } from "react";
import { Typography, Box, Button } from "@mui/material";
import { getLayoutLine } from "../../../components/layout/getLayoutLine";
import { postDownload } from "../../../fetch/postDownload";
export function Gamer(props) {
  const { panel: __panel__ } = props;
  const __ref__ = useRef(null);
  return (
    <Box className="pk__page">
      <Box className="pk__block">
        <Box className="pk__info">
          <Typography variant="caption" color="secondary.dark">
            Last updated July, 22 2026
          </Typography>
          <Button
            className="link"
            component="a"
            onClick={() =>
              postDownload("polycaik_gamer_agreement.pdf", __ref__.current)
            }
          >
            Download (PDF)
          </Button>
        </Box>
        <Typography variant="h4" color="#606060" paddingTop={5}>
          <strong>Polycaik Gamer Agreement</strong>
        </Typography>
        <Typography variant="h6" color="#007eff">
          <button className="link" onClick={() => __panel__("__platform__")}>
            Schedule B To Platform Agreement
          </button>
        </Typography>
        <Box className="pk__body" ref={__ref__}>
          {getLayoutLine([
            <>
              This Polycaik Gamer Agreement (the “
              <span className="token">Gamer Agreement</span>”) is between (i) a
              Participant posting one or more Games on the Polycaik Platform
              under the Platform Agreement (“
              <span className="token">Developer</span>”) and (ii) a Participant
              playing Developer’s Game under the Polycaik Platform Agreement (“
              <span className="token">Gamer</span>
              ”) (each a “<span className="token">Party</span>” and together the
              “<span className="token">Parties</span>”).
            </>,
            <>
              <span className="token header caution">WHEREAS,</span> Developer
              has developed certain Games and offers these Games for use via the
              Polycaik Platform;
            </>,
            <>
              <span className="token header caution">WHEREAS,</span> Gamer
              wishes to use the Developer’s Games on the Polycaik Platform, and
              Developer is willing to permit such use, all in accordance with
              the terms and conditions set out below;
            </>,
            <>
              <span className="token header caution">NOW, THEREFORE,</span> in
              consideration of the mutual promises set forth in this Gamer
              Agreement, the Parties, intending to be legally bound, agree as
              follows:
            </>,
          ])}
          <Box className="stub stub--title">
            <span className="token token--slot">1.</span>
            <div>
              <span className="token header">Acceptance of Terms.</span>By
              clicking “I accept” to the Platform Agreement, each Party accepts
              and agrees to be bound by the terms and conditions set out in this
              Gamer Agreement. If a Party does not agree to these terms and
              conditions, that Party must not post, access, or use Games via the
              Platform.
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token token--slot">2.</span>
            <div>
              <span className="token header">Definitions.</span>Capitalized
              terms have the meaning set forth in context below or in{" "}
              <button
                className="link"
                onClick={() => __panel__("__glossary__")}
              >
                Uniform Definitions
              </button>
              .
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token token--slot">3.</span>
            <div>
              <span className="token header">
                Acknowledgment of Platform Agreement.
              </span>
              Each Party acknowledges (i) that it has separately entered into
              the Platform Agreement with Polycaik and is bound by its terms;
              and (ii) that this Gamer Agreement creates rights and obligations
              between Developer and Gamer separate from the Platform Agreement.
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token token--slot">4.</span>
            <span className="token header">Grant of Rights.</span>
          </Box>
          <Box className="stub">
            <span className="token token--slot">4.1.</span>
            <div>
              <span className="token header">
                License to Access and Use Games.
              </span>
              Developer hereby grants Gamer, under Developer’s Intellectual
              Property Rights and during the Term, a non-exclusive,
              non-sublicensable, and non-transferable license to access and use
              Developer’s Games via the Platform. Gamer may not share this
              license and associated access to Developer’s Games with others.
            </div>
          </Box>
          <Box className="stub">
            <span className="token token--slot">4.2.</span>
            <div>
              <span className="token header">
                License to User Generated Content.
              </span>
              One or more of Developer’s Games may permit Gamer to create (or
              upload) User-Generated Content and use such User-Generated Content
              in connection with the Games. Gamer hereby grants to Developer,
              under Gamer’s Intellectual Property Rights, a non-exclusive,
              perpetual, irrevocable, royalty-free, fully sublicensable license
              to use, reproduce, modify, display, distribute, and create
              derivative works of User-Generated Content that Gamer submits to
              Developer’s Games, solely in connection with the Game (and future
              editions of the Game) to which Gamer submits such User-Generated
              Content.
            </div>
          </Box>
          <Box className="stub">
            <span className="token token--slot">4.3.</span>
            <div>
              <span className="token header">Ownership.</span>Except for the
              rights Developer grants to Gamer under Section 4.1 (License to
              Access and Use Games), as between Developer and Gamer, Developer
              owns all right, title, and interest in Developer’s Games, and all
              Intellectual Property Rights embodied in such Games. Except for
              the rights Gamer grants to Developer under Section 4.2 (License to
              User-Generated Content), as between Gamer and Developer, Gamer
              owns all right, title, and interest in Gamer’s User-Generated
              Content, and all Intellectual Property Rights embodied in such
              User-Generated Content.
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token token--slot">5.</span>
            <div>
              <span className="token header">Compensation.</span>Gamer will
              compensate Developer for Gamer’s use of Developer’s Games, all in
              accordance with the Platform Agreement.
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token token--slot">6.</span>
            <div>
              <span className="token header">
                Developer’s Representations and Warranties.
              </span>
              Developer represents and warrants to Gamer that: (i) Developer’s
              Games, (excluding any of Gamer’s User-Generated Content), do not
              infringe the Intellectual Property Rights of third parties; (ii)
              Developer’s Games do not contain any viruses, malware, or other
              harmful code; and (iii) Developer will comply with applicable law.
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token token--slot">7.</span>
            <div>
              <span className="token header">
                Gamer’s Representations and Warranties.
              </span>
              Gamer represents and warrants to Developer that: (i) Gamer’s
              User-Generated Content does not infringe the Intellectual Property
              Rights of third parties; (ii) Gamer’s User-Generated Content does
              not contain any viruses, malware, or other harmful code; and (iii)
              Gamer will comply with applicable law.
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token token--slot">8.</span>
            <span className="token header">Indemnification.</span>
          </Box>
          <Box className="stub">
            <span className="token token--slot">8.1.</span>
            <div>
              <span className="token header">Gamer Indemnification.</span>
              Gamer shall indemnify, defend, and hold harmless Developer from
              and against any and all third party claims, damages, losses,
              liabilities, costs, and expenses (including reasonable attorneys’
              fees) arising out of or related to a violation or misappropriation
              of such third party’s Intellectual Property Rights by Gamer’s
              User-Generated Content.
            </div>
          </Box>
          <Box className="stub">
            <span className="token token--slot">8.2.</span>
            <div>
              <span className="token header">Developer Indemnification.</span>
              Developer shall indemnify, defend, and hold harmless Gamer from
              and against any and all third party claims, damages, losses,
              liabilities, costs, and expenses (including reasonable attorneys’
              fees) arising out of or related to a violation or misappropriation
              of such third party’s Intellectual Property Rights by Developer’s
              Game.
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token token--slot">9.</span>
            <div>
              <span className="token header">Restrictions.</span>Gamer shall
              not: (a) reverse engineer, decompile, disassemble, or otherwise
              attempt to derive the source code or underlying algorithms of any
              Game or any component thereof; (b) modify, adapt, translate, or
              create derivative works based on any Game, except as expressly
              permitted by the Platform; (c) copy, distribute, sublicense, rent,
              lease, or lend any Game or any portion thereof; (d) remove, alter,
              or obscure any proprietary notices, labels, or marks on or in any
              Game; or (e) use any Game for any unlawful purpose.
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token">10.</span>
            <div>
              <span className="token header">Data Handling and Privacy.</span>
              The Polycaik Privacy Policy governs the collection and treatment
              of Personal Information.
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token">11.</span>
            <div>
              <span className="token header">Limitation of Liability.</span>
              <span className="caution">
                EXCEPT WITH RESPECT TO GAMER’S INDEMNIFICATION OBLIGATIONS UNDER
                SECTION 8.1
              </span>{" "}
              (Gamer Indemnification){" "}
              <span className="caution">
                AND DEVELOPER’S INDEMNIFICATION OBLIGATIONS UNDER SECTION 8.2
              </span>{" "}
              (Developer Indemnification),{" "}
              <span className="caution">
                ONE PARTIES’ TOTAL AGGREGATE LIABILITY TO THE OTHER PARTY UNDER
                THIS GAMER AGREEMENT SHALL NOT EXCEED THE TOTAL AMOUNT FEES THE
                GAMER HAS PAID OR OWES UNDER THE PLATFORM AGREEMENT. IN NO EVENT
                SHALL EITHER PARTY BE LIABLE FOR ANY INDIRECT, SPECIAL,
                INCIDENTAL, PUNITIVE, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                ARISING OUT OF OR RELATED TO THIS AGREEMENT.
              </span>
              .
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token">12.</span>
            <div>
              <span className="token header">Term.</span>
              This Gamer Agreement shall commence once both Developer and Gamer
              have entered into the Platform Agreement and, unless earlier
              terminated pursuant to Section 13 (Termination), shall continue
              for the period specified in the applicable Access Plan (the “
              <span className="token">Term</span>”).
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token">13.</span>
            <span className="token header">Termination.</span>
          </Box>
          <Box className="stub">
            <span className="token">13.1.</span>
            <div>
              <span className="token header">
                Termination for Material Breach.
              </span>
              Either Party may terminate this Gamer Agreement upon written
              notice if the other Party materially breaches this Gamer Agreement
              and fails to cure such breach within thirty (30) days after
              receipt of written notice thereof.
            </div>
          </Box>
          <Box className="stub">
            <span className="token">13.2.</span>
            <div>
              <span className="token header">
                Termination By Developer for Convenience.
              </span>
              Developer may terminate this Gamer Agreement for convenience as to
              one or more (or all) of its Games on ten (10) days’ notice, and
              Gamer will be notified of such termination via the Platform or the
              posted unavailability of the Game or Games at issue.
            </div>
          </Box>
          <Box className="stub">
            <span className="token">13.3.</span>
            <div>
              <span className="token header">
                Termination by Gamer for Convenience.
              </span>
              Gamer may terminate this Gamer Agreement by ceasing to access or
              use Developer’s Games.
            </div>
          </Box>
          <Box className="stub">
            <span className="token">13.4.</span>
            <div>
              <span className="token header">
                Effect of Termination or Expiration.
              </span>
              Upon termination or expiration of this Gamer Agreement, the
              Gamer's license to use Developer’s Games shall immediately cease.
            </div>
          </Box>
          <Box className="stub">
            <span className="token">13.5.</span>
            <div>
              <span className="token header">
                Game Continuity and Continuing Rights.
              </span>
              If Gamer, as of the termination or expiration of this Gamer
              Agreement, has submitted User-Generated Content to the Platform (“
              <span className="token">Existing Content</span>”), and if
              Developer has incorporated the Existing Content in one or more of
              Developer’s Games as of such termination or expiration (each an “
              <span className="token">Existing Game</span>”), then Gamer agrees
              that Developer’s license under Section 4.2 (License to
              User-Generated Content) shall remain in full force and effect
              after termination or expiration of this Gamer Agreement and shall
              continue for so long as Developer offers the Existing Game and
              later editions of such Game.
            </div>
          </Box>
          <Box className="stub">
            <span className="token">13.6.</span>
            <div>
              <span className="token header">Platform Agreement.</span>The
              termination of this Gamer Agreement does not automatically
              terminate the Platform Agreement. If a Party desires to terminate
              its Platform Agreement, it should do so under the terms of the
              Platform Agreement. Conversely, termination of the Platform
              Agreement shall automatically terminate this Gamer Agreement.
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token">14.</span>
            <span className="token header">General Provisions.</span>
          </Box>
          <Box className="stub">
            <span className="token">14.1.</span>
            <div>
              <span className="token header">Governing Law.</span>This Gamer
              Agreement shall be governed by and construed in accordance with
              the laws of State of New Jersey.
            </div>
          </Box>
          <Box className="stub">
            <span className="token">14.2.</span>
            <span className="token header">Dispute Resolution.</span>
          </Box>
          <Box className="stub" flexDirection="column" paddingBottom={0}>
            <Box className="stub">
              <span className="token">14.2.1.</span>
              <div>
                <span className="token header">Binding Arbitration.</span>
                Any controversy or claim arising out of or relating to this
                Gamer Agreement shall be resolved by confidential arbitration
                conducted in Passaic County, New Jersey, and administered by
                JAMS in accordance with its applicable rules. The JAMS rules for
                selection of an arbitrator shall be followed, except that the
                arbitrator shall be a former judge. Upon conclusion of any
                arbitration proceedings hereunder, the arbitrator shall render
                findings of fact and conclusions of law and a written opinion
                setting forth the basis and reasons for any decision the
                arbitrator has reached and shall deliver such documents to each
                Party to this Gamer Agreement along with a signed copy of the
                award in accordance with applicable JAMS rules.
              </div>
            </Box>
            <Box className="stub">
              <span className="token">14.2.2.</span>
              <div>
                <span className="token header">
                  Enforcement; Jurisdiction; Arbitration Remedies.
                </span>
                Any judgment upon the award rendered by the arbitrator may be
                entered in any state or federal court that has requisite subject
                matter jurisdiction and that sits in the judicial district that
                includes Passaic County, New Jersey and the Parties agree to
                submit to the in personam jurisdiction of such courts for
                purposes of confirming any such award and entering judgment
                thereon. The arbitrator shall have the authority to grant any
                equitable and legal remedies that would be available in any
                judicial proceeding instituted to resolve a disputed matter,
                subject to any waivers of such remedies made by any Party in
                this Gamer Agreement. The Parties waive any objection that they
                may have as to jurisdiction or venue in any of the above courts.
              </div>
            </Box>
          </Box>
          <Box className="stub">
            <span className="token">14.3.</span>
            <div>
              <span className="token header">No Waiver; Entire Agreement.</span>
              Neither Party will be treated as having waived any rights by not
              exercising (or delaying the exercise of) any rights under this
              Gamer Agreement. This Gamer Agreement states all terms agreed
              between the Parties and cancels and replaces all other agreements
              between the Parties relating to its subject matter. If any term
              (or part of a term) of this Gamer Agreement is invalid, illegal,
              or unenforceable, the rest of the Gamer Agreement will remain in
              effect.
            </div>
          </Box>
          <Box className="stub">
            <span className="token">14.4.</span>
            <div>
              <span className="token header">Remedies.</span>Unless otherwise
              provided in this Gamer Agreement, no remedy is exclusive, and a
              Party shall be entitled to assert all available rights and
              remedies.
            </div>
          </Box>
          <Box className="stub">
            <span className="token">14.5.</span>
            <div>
              <span className="token header">Force Majeure.</span>
              Neither Party shall be liable for a failure or delay in the
              performance of its obligations under this Gamer Agreement due to
              strikes (except with respect to its own labor force), shortages,
              riots, pandemic, insurrection, acts of God, war, governmental
              action, power or connectivity interruptions, or other causes
              beyond the reasonable control of such Party.
            </div>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
